import React from 'react';
import IconButton from 'material-ui/IconButton';
import Avatar from 'material-ui/Avatar';
import {get} from 'engine/dataServices';
import jMoment from 'moment-jalaali';

class TimerView extends React.Component {

    constructor() {
        super();

        jMoment.loadPersian({dialect: 'persian-modern'});
        const _dayName = jMoment().format('dddd');
        const _dayNum = jMoment().format('jD');
        const _cal = jMoment().format('jMMMM jYYYY');

        this.state = {
            anchorEl: undefined,
            menuState: false,
            dayName: _dayName,
            dayNum: _dayNum,
            cal: _cal,
            cart: 0,
            first: 0,
            second: 0,
            third: 0
        }
    }

    componentWillMount() {
        this.loadData();
    }

    async loadData() {
        const res = await get('Order/OrdersInprogressPercent');
        if (res.status == 200) {
            const responseData = await res.json();
            this.setState({
                cart: responseData.Cart,
                first: responseData.Quarter,
                second: responseData.Half,
                third: responseData.ThreeQuarters
            });
        }
    }

    render() {
        const {headerColor} = this.props;
        const {dayName, dayNum, cal} = this.state;
        const {cart, first, second, third} = this.state;

        return (
            <div className="jr-card">

                <div className={`jr-card-header-color text-center bg-${headerColor}`}>
                    {/*<div className="jr-card-header-top">
                        <IconButton className="jr-menu-icon mr-auto" aria-label="Menu">
                            <span className="menu-icon bg-white"/>
                        </IconButton>
                    </div>*/}

                    <Avatar className="bg-blue lighten-4 size-100 mx-auto mb-3"><h1
                        className="m-0 text-blue text-darken-4 font-weight-bold">{dayNum}</h1></Avatar>


                    <div className="jr-card-hd-content text-white">
                        <h2 className="text-white">{dayName}</h2>
                        <p className="font-weight-bold">{cal}</p>
                    </div>
                </div>
                <div className="jr-card-body">

                    <div className="d-flex flex-column">

                        <div className="list-line-item">
                            <div className="list-line-badge bg-danger"/>

                            <div className="list-line-content">
                                <h3 className="text-danger mb-1">در سبد خرید</h3>
                                <p className="text-muted">تعداد {cart} مورد</p>
                            </div>
                        </div>

                        <div className="list-line-item">
                            <div className={`list-line-badge bg-primary`}/>

                            <div className="list-line-content">
                                <h3 className={`mb-1 text-primary`}>25% پیشرفت</h3>
                                <p className="text-muted">تعداد {first} مورد</p>
                            </div>
                        </div>

                        <div className="list-line-item">
                            <div className="list-line-badge bg-success"/>

                            <div className="list-line-content">
                                <h3 className="text-success mb-1">50% پیشرفت</h3>
                                <p className="text-muted">تعداد {second} مورد</p>
                            </div>
                        </div>

                        <div className="list-line-item">
                            <div className={`list-line-badge bg-secondary`}/>

                            <div className="list-line-content">
                                <h3 className={`mb-1 text-secondary`}>75% پیشرفت</h3>
                                <p className="text-muted">تعداد {third} مورد</p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}

export default TimerView;




// WEBPACK FOOTER //
// ./components/toliton/desktop/TimerView/index.js